import { Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const SERVICES = [
  {
    title: "Ny hjemmeside",
    price: "Fra 3.995 kr.",
    text: "En skræddersyet, professionel hjemmeside bygget fra bunden — hurtig, mobilvenlig og skabt til at skabe tillid hos dine kunder.",
    features: [
      "Op til 4 standardsider i moderne design",
      "Mobil- og tabletvenlig",
      "Kontaktformular & Google Maps",
      "Grundlæggende SEO-opsætning",
    ],
  },
  {
    title: "Redesign af eksisterende side",
    price: "Fast tilbud før opstart",
    text: "Har du en ældre side, der trænger til et løft? Vi forvandler den til en moderne side, der præsenterer din virksomhed fra sin bedste side.",
    features: [
      "Moderne grafisk opdatering",
      "Forbedret brugervenlighed",
      "Optimeret til mobil",
      "Vi overfører dit eksisterende indhold",
    ],
  },
  {
    title: "Løbende vedligeholdelse",
    price: "Fra 499 kr./md.",
    text: "Slip for teknisk besvær. Vi holder din side opdateret, sikker og kørende — så den altid virker, når kunderne kigger forbi.",
    features: [
      "Opdateringer & sikkerhedskopier",
      "Mindre rettelser hver måned",
      "Hurtig, personlig support",
      "Ingen binding",
    ],
  },
];

export const Services = () => (
  <section id="services" className="py-20 sm:py-28 bg-zinc-50/70" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 mb-4">
          Services
        </p>
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-zinc-900 max-w-2xl">
          Alt hvad din virksomhed har brug for online
        </h2>
        <p className="mt-4 text-base sm:text-lg text-zinc-600 max-w-xl">
          Tre enkle ydelser, der dækker hele rejsen — fra første side til løbende drift.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-8 lg:grid-cols-3">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.12}>
            <div
              data-testid={`service-card-${i + 1}`}
              className="h-full flex flex-col bg-white border border-zinc-200/80 rounded-2xl p-8 hover:border-zinc-900 hover:-translate-y-1 transition-all duration-300"
            >
              <h3 className="text-xl font-semibold text-zinc-900">{s.title}</h3>
              <p className="mt-2 text-sm font-medium text-zinc-500">{s.price}</p>
              <p className="mt-4 text-base text-zinc-600 leading-relaxed">{s.text}</p>
              <ul className="mt-6 space-y-3 pt-6 border-t border-zinc-100">
                {s.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-zinc-600">
                    <Check className="w-4 h-4 mt-0.5 text-emerald-500 shrink-0" aria-hidden="true" />
                    {f}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
